import { ACTIVE_ANALYSIS_PROVIDERS } from "./analysisProviders";

export const VAULT_PROVIDERS = [
  ...ACTIVE_ANALYSIS_PROVIDERS,
  "anthropic",
  "openai",
  "finnhub",
  "alphaVantage",
  "polygon",
  "nyt",
  "newsapi",
  "cmc",
  "fmp",
  "fred",
  "eia",
] as const;

export type VaultProvider = typeof VAULT_PROVIDERS[number];

export interface VaultEntry {
  value: string;
  savedAt: string | null;
}

export type VaultSnapshot = Partial<Record<VaultProvider, VaultEntry>>;

export interface ProfileVaultDocument {
  version: 2;
  entries: VaultSnapshot;
}

export interface ProfileVaultSummary {
  revision: number;
  updatedAt: string | null;
  providers: VaultProvider[];
}

export type VaultMergeState = "only_local" | "only_cloud" | "same" | "conflict";

export interface VaultPreviewProvider {
  provider: VaultProvider;
  state: VaultMergeState;
  localSavedAt: string | null;
  cloudSavedAt: string | null;
}

export interface VaultRecoveryPreview {
  revision: number;
  updatedAt: string | null;
  providers: VaultPreviewProvider[];
}

export type VaultConflictResolution = "local" | "cloud";
export type VaultConflictResolutions = Partial<Record<VaultProvider, VaultConflictResolution>>;

export function isVaultProvider(value: string): value is VaultProvider {
  return (VAULT_PROVIDERS as readonly string[]).includes(value);
}
